/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_NeverInputs */

const fr_account_audit_never = /** @type {(inputs: Account_Audit_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jamais`)
};

/**

* @param {Account_Audit_NeverInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_never = /** @type {((inputs?: Account_Audit_NeverInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_NeverInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_never(inputs)
});